import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import defaultImg from './../../../images/task/img1.jpg';
import { var_api, image_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

const AgencyMaster = () => {
  const tableHeaders = [
    "#",
    "Logo",
    "City",
        "Supplier ",

    "Agency ",
    "Mobile",
    "Status",
    "Action"
  ];

  const [agencyData, setAgencyData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
    const [filteredCity, setFilteredCity] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [cityData, setCityData] = useState([]);
  
  const [formData, setFormData] = useState({
    id: null,
    warehouse_id: localStorage.getItem('warehouse_id') || '',
    agency_name: '',
    agency_logo_image: '',
    vee_supplier_code: '',
    supplier_name: '',
    supplier_profile: '',
    supplier_mobile: '',
    agency_contact_1: '',
    agency_contact_2: '',
    agency_email: '',
    agency_address: '',
    agency_website: '',
    agency_whatsapp_no: '',
    is_active: 1,
    gst_no: '',
    remarks: '',
    bank_ac_no: '',
    bank_ifsc: '',
    ac_holdername: '',
    branch_name: '',
    bank_name: '',
    fssai_no: ''
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
const [viewModal, setViewModal] = useState(false);
const [viewData, setViewData] = useState({});

useEffect(() => {
  const loadAll = async () => {
    try {
      setInitialLoading(true);
      await fetchCityData();  // ✅ First load city list
      await fetchAgencyData(); // ✅ Then load agencies (with cityData available)
    } catch (err) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };
  loadAll();
}, []);



  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchAgencyData();
    } catch (error) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchAgencyData = async () => {
    const warehouseId = localStorage.getItem('warehouse_id') || '';
  try {
    const res = await axios.get(`${var_api}ci_veemart_supplier_master/get-warehouse/${warehouseId}`);
    const agencies = res.data || [];

    // Map city_id to city_name from cityData
    const mappedAgencies = agencies.map(item => {
      const city = cityData.find(c => c.id === item.city_id);
      return {
        ...item,
        city_name: city ? city.city_name : "-", // fallback if not found
      };
    });

    setAgencyData(mappedAgencies);
  } catch {
    toast.error("Failed to fetch data");
  }
};


    const fetchCityData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_city_master/get`);
      setCityData(res.data || []);
      setFilteredCity(res.data || []);
      setCityList(res.data || []); // ✅ add this line
    } catch (err) {
      console.error("Failed to fetch city data", err);
    }
  };
  const handleViewClick = (item) => {
  setViewData(item);
  setViewModal(true);
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleAddClick = () => {
    setFormData({
      id: null,
      warehouse_id: localStorage.getItem('warehouse_id') || '',
      agency_name: '',
      agency_logo_image: '',
      vee_supplier_code: '',
      supplier_name: '',
      supplier_profile: '',
      supplier_mobile: '',
      agency_contact_1: '',
      agency_contact_2: '',
      agency_email: '',
      agency_address: '',
      agency_website: '',
      agency_whatsapp_no: '',
      is_active: 1,
      gst_no: '',
      remarks: '',
      bank_ac_no: '',
      bank_ifsc: '',
      ac_holdername: '',
      branch_name: '',
      bank_name: '',
      fssai_no: ''
    });
    setFile(null);
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setFile(null);
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.agency_name.trim()) newErrors.agency_name = "Agency name is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      const form = new FormData();
      Object.keys(formData).forEach(key => {
        if (key === "agency_logo_image" && file) {
          form.append(key, file);
        } else {
          form.append(key, formData[key]);
        }
      });

      const headers = { headers: { 'Content-Type': 'multipart/form-data' } };
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}ci_veemart_supplier_master/update/${formData.id}`, form, headers);
      } else {
        res = await axios.post(`${var_api}ci_veemart_supplier_master/post`, form, headers);
      }

      toast.success(res?.data?.message || "Agency saved successfully!");
      setShowModal(false);
      setFormData({});
      setFile(null);
      fetchAgencyData();
    } catch (err) {
      if (err?.response?.data?.errors) setErrors(err.response.data.errors);
      toast.error(err?.response?.data?.message || "Failed to save data");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = agencyData.filter(item =>
    Object.values(item).some(val => String(val).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search agency..."
                  value={searchQuery}
                  onChange={e => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan={tableHeaders.length} className="text-center text-muted py-3">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                            <img
                              src={item.agency_logo_image ? `${image_api}${item.agency_logo_image.replace(/^test\//, '')}` : defaultImg}
                              alt="agency"
                              width="40"
                              height="40"
                              className="rounded"
                              onClick={() => window.open(`${image_api}${item.agency_logo_image.replace(/^test\//, '')}`, '_blank')}
                              style={{ cursor: 'pointer' }}
                            />
                          </td>
 <td>
                            {
                              cityData.find((c) => c.id === item.city_id)
                                ?.city_name
                            }
                          </td>
                          <td
  style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
  onClick={() => handleViewClick(item)}
>
  {item.supplier_name || "—"}
</td>

                          <td>{item.agency_name}</td>
                          <td>{item.supplier_mobile}</td>
                          <td>
                            <span className={`badge ${item.is_active === 1 || item.is_active === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                              {item.is_active === 1 || item.is_active === 'Active' ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td className="text-center">
                            <Link to="#" className="btn shadow btn-xs sharp me-1" style={{ backgroundColor: "#007bff", color: "white" }} onClick={() => handleEditClick(item)}>
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>
<Modal show={viewModal} onHide={() => setViewModal(false)} size="xl" centered>
  <Modal.Header closeButton>
    <Modal.Title>View Agency Details</Modal.Title>
  </Modal.Header>

  <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
    <Row>
      {/* Logo */}
      <Col md={12} className="text-center mb-4">
        <img
          src={
            viewData.agency_logo_image
              ? `${image_api}${viewData.agency_logo_image.replace(/^test\//, '')}`
              : defaultImg
          }
          alt="Agency Logo"
          width="100"
          height="100"
          className="rounded border"
        />
      </Col>

      {/* All Fields in 4 Columns */}
      {[
        { label: "Agency Name", value: viewData.agency_name },
        { label: "Supplier Name", value: viewData.supplier_name },
        { label: "Supplier Mobile", value: viewData.supplier_mobile },
        { label: "Supplier Profile", value: viewData.supplier_profile },
        { label: "City ID", value: viewData.city_id },
        { label: "VEE Supplier Code", value: viewData.vee_supplier_code },
        { label: "Agency Contact 1", value: viewData.agency_contact_1 },
        { label: "Agency Contact 2", value: viewData.agency_contact_2 },
        { label: "Email", value: viewData.agency_email },
        { label: "Website", value: viewData.agency_website },
        { label: "WhatsApp No", value: viewData.agency_whatsapp_no },
        { label: "GST No", value: viewData.gst_no },
        { label: "FSSAI No", value: viewData.fssai_no },
        { label: "Address", value: viewData.agency_address },
        { label: "Bank Name", value: viewData.bank_name },
        { label: "Branch Name", value: viewData.branch_name },
        { label: "A/C Holder Name", value: viewData.ac_holdername },
        { label: "Bank A/C No", value: viewData.bank_ac_no },
        { label: "Bank IFSC", value: viewData.bank_ifsc },
        { label: "Remarks", value: viewData.remarks },
        {
          label: "Status",
          value:
            viewData.is_active === 1 || viewData.is_active === "Active"
              ? "Active"
              : "Inactive",
        },
      ].map((field, idx) => (
        <Col md={3} key={idx} className="mb-3">
          <strong>{field.label}:</strong>
          <div className="text-muted">
            {field.value ? field.value : <span className="text-secondary">—</span>}
          </div>
        </Col>
      ))}
    </Row>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="danger" onClick={() => setViewModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

     <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered>
  <Modal.Header closeButton>
    <Modal.Title>{isEditMode ? "Edit Agency" : "Add Agency"}</Modal.Title>
  </Modal.Header>

  <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
    <Form onSubmit={handleSubmit}>
      <Row>
        {/* City ID */}
 {/* <Col md={3}>
   <Form.Group className="mb-2">
     <Form.Label>
       City <span className="text-danger">*</span>
     </Form.Label>
     <Select
       name="city_id"
       value={cityList.find(c => c.id === formData.city_id) || null}
       onChange={(selectedOption) => {
         setFormData({
           ...formData,
           city_id: selectedOption?.id || ''
         });
         setErrors(prev => ({ ...prev, city_id: '' }));
       }}
       options={cityList} // ✅ show all cities — independent of district
       getOptionLabel={(e) => e.city_name}
       getOptionValue={(e) => e.id}
       placeholder="Select City"
       className="narrow-input"
       isClearable
       isSearchable
       isDisabled={false} // ✅ always enabled
     />
     {errors.city_id && (
       <div className="text-danger small mt-1">{errors.city_id}</div>
     )}
   </Form.Group>
 </Col> */}


        {/* Agency Name */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              Agency Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="agency_name"
              value={formData.agency_name}
              placeholder="Enter agency name"
              onChange={handleInputChange}
            />
            {errors.agency_name && (
              <div className="text-danger small mt-1">{errors.agency_name}</div>
            )}
          </Form.Group>
        </Col>

        {/* Supplier Name */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Supplier Name</Form.Label>
            <Form.Control
              type="text"
              name="supplier_name"
              value={formData.supplier_name}
              placeholder="Enter supplier name"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* Supplier Mobile */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Supplier Mobile</Form.Label>
            <Form.Control
              type="text"
              name="supplier_mobile"
              value={formData.supplier_mobile}
              placeholder="Enter supplier mobile"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* Supplier Profile */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Supplier Profile</Form.Label>
            <Form.Control
              type="text"
              name="supplier_profile"
              value={formData.supplier_profile}
              placeholder="Enter supplier profile"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* VEE Supplier Code */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>VEE Supplier Code</Form.Label>
            <Form.Control
              type="text"
              name="vee_supplier_code"
              value={formData.vee_supplier_code}
              placeholder="Enter VEE supplier code"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* Contacts */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Agency Contact 1</Form.Label>
            <Form.Control
              type="text"
              name="agency_contact_1"
              value={formData.agency_contact_1}
              placeholder="Enter contact number"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Agency Contact 2</Form.Label>
            <Form.Control
              type="text"
              name="agency_contact_2"
              value={formData.agency_contact_2}
              placeholder="Enter secondary contact number"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* Email */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Agency Email</Form.Label>
            <Form.Control
              type="email"
              name="agency_email"
              value={formData.agency_email}
              placeholder="Enter email"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* Website */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Website</Form.Label>
            <Form.Control
              type="text"
              name="agency_website"
              value={formData.agency_website}
              placeholder="Enter website"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* WhatsApp */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>WhatsApp No</Form.Label>
            <Form.Control
              type="text"
              name="agency_whatsapp_no"
              value={formData.agency_whatsapp_no}
              placeholder="Enter WhatsApp number"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* GST */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>GST No</Form.Label>
            <Form.Control
              type="text"
              name="gst_no"
              value={formData.gst_no}
              placeholder="Enter GST number"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* FSSAI */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>FSSAI No</Form.Label>
            <Form.Control
              type="text"
              name="fssai_no"
              value={formData.fssai_no}
              placeholder="Enter FSSAI number"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* Address */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="agency_address"
              value={formData.agency_address}
              placeholder="Enter address"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* Bank Details */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Bank Name</Form.Label>
            <Form.Control
              type="text"
              name="bank_name"
              value={formData.bank_name}
              placeholder="Enter bank name"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Branch Name</Form.Label>
            <Form.Control
              type="text"
              name="branch_name"
              value={formData.branch_name}
              placeholder="Enter branch name"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Account Holder Name</Form.Label>
            <Form.Control
              type="text"
              name="ac_holdername"
              value={formData.ac_holdername}
              placeholder="Enter account holder name"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Bank A/C No</Form.Label>
            <Form.Control
              type="text"
              name="bank_ac_no"
              value={formData.bank_ac_no}
              placeholder="Enter account number"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Bank IFSC</Form.Label>
            <Form.Control
              type="text"
              name="bank_ifsc"
              value={formData.bank_ifsc}
              placeholder="Enter IFSC code"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* Remarks */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Remarks</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="remarks"
              value={formData.remarks}
              placeholder="Enter remarks"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>

        {/* Logo Upload */}
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Agency Logo</Form.Label>
            {isEditMode && formData.agency_logo_image && !file && (
              <div className="mb-2 d-flex gap-2 align-items-center">
                <img
                  src={`${image_api}${formData.agency_logo_image.replace(/^test\//, '')}`}
                  alt="Preview"
                  width="80"
                  className="rounded border"
                />
              </div>
            )}
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </Form.Group>
        </Col>

        {/* Active Status — only in Edit mode */}
        {isEditMode && (
          <Col md={6}>
            <Form.Group className="mb-3 d-flex align-items-center gap-2">
              <Form.Label className="mb-0">
                {formData.is_active === 1 || formData.is_active === "Active"
                  ? "Active"
                  : "Inactive"}
              </Form.Label>
              <Form.Check
                type="switch"
                id="active-status-switch"
                checked={
                  formData.is_active === 1 || formData.is_active === "Active"
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    is_active: e.target.checked ? 1 : 0,
                  })
                }
                className={
                  formData.is_active === 1 || formData.is_active === "Active"
                    ? "custom-switch-green"
                    : ""
                }
              />
            </Form.Group>
          </Col>
        )}
      </Row>

      {/* Footer Buttons */}
      <div className="d-flex justify-content-end gap-2 mt-3">
        {!isEditMode ? (
          <>
            <Button variant="secondary" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Creating...
                </>
              ) : (
                "Create"
              )}
            </Button>
            <Button
              variant="danger"
              type="reset"
              disabled={loading}
              onClick={() =>
                setFormData({
                  ...formData,
                  agency_name: "",
                  supplier_name: "",
                  supplier_mobile: "",
                  agency_logo_image: "",
                })
              }
            >
              Reset
            </Button>
          </>
        ) : (
          <>
            <Button variant="warning" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Updating...
                </>
              ) : (
                "Update"
              )}
            </Button>
            <Button
              variant="danger"
              onClick={() => setShowModal(false)}
              disabled={loading}
            >
              Cancel
            </Button>
          </>
        )}
      </div>
    </Form>
  </Modal.Body>

 
</Modal>


        <style>{`
          .custom-switch-green .form-check-input:checked {
            background-color: #28a745 !important;
            border-color: #28a745 !important;
          }
        `}</style>
      </Card>

      <ToastContainer />
    </>
  );
};

export default AgencyMaster;
